import React from 'react';
import { getConfig } from '../../../config';
import { getLocaleLanguage, LanguageType, openURL } from '../../../lib';

interface IProps {
  readonly lang?: LanguageType | null;
}
export const ItemHelperComponent = (props: IProps) => {
  // const deployArea: DeployArea = getConfig()?.deployArea;
  // const isWoa =
  //   deployArea === DeployArea.woa && getConfig().env === 'production';

  const currentStoreLanguage =
    props.lang || getLocaleLanguage() || LanguageType.en_US;
  const links =
    getConfig().documentConfig.consoleHelperLinks[currentStoreLanguage];
  const link = links.find((link) => link.label === 'InGame') || links[0];
  const url =
    link?.url.indexOf(getConfig()?.consoleURL) !== -1
      ? link?.url
      : `${getConfig().consoleURL}${link?.url}`;

  // 如果是内网
  // const IWIKI_WOA_DOMAIN = 'https://iwiki.woa.com/p/4009143771'; // 内网顶部疑问icon跳转
  // const url = isWoa ? IWIKI_WOA_DOMAIN : link.url;
  return (
    <li>
      <a className="action-item" onClick={() => openURL(url)}>
        <span className="action-icon">
          <svg>
            <use xlinkHref="#help-outline"></use>
          </svg>
        </span>
      </a>
    </li>
  );
};
